export default {
  path: '/customers',
  name: 'customers',
  component: () => import('../components/customer/Layout'),
  redirect: { name: 'CustomerList' },
  meta: {
    breadcrumb: 'customer.customers',
  },
  children: [
    {
      name: 'CustomerList',
      path: '',
      component: () => import('../views/customer/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'CustomerCreate',
      path: 'new',
      component: () => import('../views/customer/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'CustomerUpdate',
      path: ':id/edit',
      component: () => import('../views/customer/Update'),
      meta: {
        breadcrumb: 'customer.customer',
      },
    },
    {
      name: 'CustomerShow',
      path: ':id',
      component: () => import('../views/customer/Show'),
      meta: {
        breadcrumb: 'customer.customer',
      },
    }
  ]
};
